import React from 'react';
import './Input.styles.css';


function Input({placeholder,type}){
    return <input type={type} placeholder={placeholder} className='input'/>
}

export default Input